module.exports = __webpack_public_path__ + "img/Levanta_Junteo Pulido R125.751b9461.png";